!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={493:(e,t,r)=>{r.d(t,{default:()=>s});const o=require("react");var n=r.n(o);const a=require("@storeblocks/box");var i=r.n(a),l=r(279);const s=function(e){var{id:t,label:r,checked:a,disabled:s=!1,onChange:c,inputProps:d}=e,p=function(e,t){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&Object.prototype.propertyIsEnumerable.call(e,o[n])&&(r[o[n]]=e[o[n]])}return r}(e,["id","label","checked","disabled","onChange","inputProps"]);const b=(0,o.useCallback)((e=>{s||c(e)}),[s,c]),u=r?`${t}-switch-label`:void 0;return n().createElement(l.SwitchBase,Object.assign({role:"presentation"},p),n().createElement(l.HiddenInput,Object.assign({id:t,"aria-labelledby":u,type:"checkbox",role:"switch",checked:a,"aria-disabled":s,onChange:b},d)),n().createElement(l.Track,null,n().createElement(l.Thumb,null)),r&&n().createElement(i(),{as:"p",ml:"16px",background:"transparent",id:u},r))}},279:(e,t,r)=>{r.d(t,{HiddenInput:()=>l,SwitchBase:()=>s,Thumb:()=>i,Track:()=>a});const o=require("styled-components");var n=r.n(o);const a=n().div`
  display: inline-flex;
  position: relative;
  flex-shrink: 0;
  height: 24px;
  width: 44px;

  background: #ddd;
  border-radius: 20px;
  cursor: pointer;

  transition: ease-in-out 0.2s;
  transition-property: background;

  &:before {
    content: '';
    position: absolute;

    top: -12px;
    bottom: -12px;
    left: 0;
    right: 0;
  }
`,i=n().div`
  width: 24px;
  height: 24px;

  border-radius: 50%;

  border: 2px solid var(--color-inactive);
  background: var(--color-background);
  box-sizing: border-box;
  transform: translateX(0px);
  transition: ease-in-out 0.2s;
  transition-property: transform, border-color;
`,l=n().input`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  opacity: 0;
  overflow: hidden;

  &:focus-visible + ${a} {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &:checked + ${a} {
    background: var(--color-selection);

    > ${i} {
      border-color: var(--color-selection);
      transform: translateX(20px);
    }
  }

  &[aria-disabled='true'] + ${a} {
    background: var(--color-disabled-variant);

    & > ${i} {
      border-color: var(--color-disabled-variant);
    }
  }
`,s=n().label.attrs({className:"switch"})`
  display: inline-flex;
  align-items: center;
`}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var a=t[o]={exports:{}};return e[o](a,a.exports,r),a.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{r.r(o),r.d(o,{default:()=>e});const e=r(493).default})(),o})()));
//# sourceMappingURL=index.js.map